import { Clock, CheckCircle, AlertCircle, Loader2 } from "lucide-react";
import "./RagStatusBadge.scss";

const RagStatusBadge = ({ status }) => {
  const getStatusConfig = () => {
    switch (status) {
      case "PENDING":
        return {
          label: "Pending",
          icon: <Clock size={12} />,
          className: "pending",
        };
      case "IN_PROGRESS":
        return {
          label: "Indexing",
          icon: <Loader2 size={12} className="spinning" />,
          className: "in_progress",
        };
      case "COMPLETED":
        return {
          label: "Indexed",
          icon: <CheckCircle size={12} />,
          className: "completed",
        };
      case "FAILED":
        return {
          label: "Failed",
          icon: <AlertCircle size={12} />,
          className: "failed",
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();

  if (!config) {
    return null;
  }

  return (
    <span className={`rag_status_badge ${config.className}`}>
      {config.icon}
      <span className="badge_label">{config.label}</span>
    </span>
  );
};

export default RagStatusBadge;
